import * as React from 'react';

import { Tag } from '@cian/components';

import { IKpIdTag } from '../../../state/tags/definitions/kp_id';
import { TagNew } from '../TagNew';
import { tagThemeSmall } from '../tag_theme';

export interface IKpIdTagItemProps {
  tag: IKpIdTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const KpIdTagItem = (props: IKpIdTagItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      Коттеджный посёлок {props.tag.text ? `«${props.tag.text}»` : `№${props.tag.value}`}
    </TagComponent>
  );
};
